import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDcyRoBARdcmbwxEZNd8cmuvJb4LfvWl94",
  authDomain: "bigresume-45b8e.firebaseapp.com",
  projectId: "bigresume-45b8e",
  storageBucket: "bigresume-45b8e.appspot.com",
  messagingSenderId: "737352572001",
  appId: "1:737352572001:web:fa6a3877c4be1b3e7d5e20",
};

const firebaseApp = initializeApp(firebaseConfig);
const auth = getAuth(firebaseApp);
const db = getFirestore(firebaseApp);
const storage = getStorage(firebaseApp);

export { auth, db, storage };
